import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
interface TermsPageProps {
  onNavigate: (page: string) => void;
}
export function TermsPage({
  onNavigate
}: TermsPageProps) {
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-25799">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-25800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25801">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Пользовательское соглашение'
        }]} className="mb-8" data-id="element-25802" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-25803">
            Пользовательское соглашение
          </h1>
          <p className="text-slate-500" data-id="element-25804">Последнее обновление: 15 мая 2026 г.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-25805">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-25806">
          <h2 data-id="element-25807">1. Предмет соглашения</h2>
          <p data-id="element-25808">
            Настоящее Пользовательское соглашение (далее — «Соглашение»)
            регулирует отношения между сервисом Astriqo (далее — «Сервис») и
            пользователем сети Интернет (далее — «Пользователь»), возникающие
            при использовании Сервиса.
          </p>

          <h2 data-id="element-25809">2. Характер предоставляемых услуг</h2>
          <p data-id="element-25810">
            Сервис предоставляет информационно-развлекательные услуги в сфере
            астрологии. Все генерируемые отчеты, прогнозы и консультации носят
            рекомендательный характер. Сервис не несет ответственности за
            решения, принятые Пользователем на основе полученной информации.
          </p>
          <p data-id="element-25811">
            <strong data-id="element-25812">Важно:</strong> Астрологические консультации и отчеты не
            заменяют профессиональную медицинскую, психологическую, юридическую
            или финансовую помощь.
          </p>

          <h2 data-id="element-25813">3. Регистрация и аккаунт</h2>
          <p data-id="element-25814">
            Для доступа к полному функционалу Сервиса Пользователь должен пройти
            процедуру регистрации. Пользователь обязуется предоставить
            достоверную информацию о себе и несет ответственность за сохранность
            своих данных для входа (логин и пароль).
          </p>

          <h2 data-id="element-25815">4. Оплата и возврат средств</h2>
          <p data-id="element-25816">
            Оплата услуг (Premium-отчеты, консультации) производится на условиях
            100% предоплаты. Поскольку автоматические отчеты являются цифровым
            контентом, доступ к которому предоставляется мгновенно, возврат
            средств за них по умолчанию не производится (в соответствии с
            законодательством о защите прав потребителей).
          </p>
          <p data-id="element-25817">
            Возврат средств за консультацию с астрологом возможен при отмене не
            позднее чем за 24 часа до назначенного времени.
          </p>

          <h2 data-id="element-25818">5. Правила поведения на платформе</h2>
          <p data-id="element-25819">Пользователю запрещается:</p>
          <ul data-id="element-25820">
            <li data-id="element-25821">
              Использовать нецензурную лексику и оскорбления при общении с
              астрологами или службой поддержки.
            </li>
            <li data-id="element-25822">
              Копировать, распространять или перепродавать материалы Сервиса
              (отчеты, статьи) без письменного разрешения.
            </li>
            <li data-id="element-25823">
              Использовать автоматизированные скрипты (боты) для сбора
              информации с Сервиса.
            </li>
          </ul>

          <h2 data-id="element-25824">6. Ограничение ответственности</h2>
          <p data-id="element-25825">
            Сервис предоставляется «как есть» (as is). Мы не гарантируем, что
            Сервис будет соответствовать вашим требованиям, будет
            предоставляться непрерывно, быстро, надежно и без ошибок.
          </p>

          <h2 data-id="element-25826">7. Изменение условий</h2>
          <p data-id="element-25827">
            Администрация Сервиса оставляет за собой право вносить изменения в
            настоящее Соглашение в любой момент. Продолжение использования
            Сервиса после внесения изменений означает согласие Пользователя с
            новой редакцией Соглашения.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-25828">
          <button onClick={() => onNavigate('privacy')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-25829">
            Политика конфиденциальности →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-25830">
            Есть вопросы? Свяжитесь с нами
          </button>
        </div>
      </div>
    </div>;
}